import { AfterViewInit, Component, ElementRef, forwardRef, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TransferState } from '@angular/platform-browser';
import {
  DxSelectBoxComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';

@Component({
  standalone: true,
  selector: 'abc-select-box',
  template: '',
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => _AbcSelectBoxComponent),
    },
  ],
})
export class _AbcSelectBoxComponent extends DxSelectBoxComponent implements AfterViewInit {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    const tooltTip = new AbcTooltipDirective(this.element);
    tooltTip.elementClassName = '.dx-texteditor-input';
  }

  ngAfterViewInit(): void {
    this.instance.endUpdate();
    this.labelMode = 'floating';
  }
}
